import { TableValue } from '~/api/sylvanus/typedefs.autogen';
import { PromptModelWorkflow } from '~/features/x-ray/debug/types';
import { FieldValueBase } from '~/features/x-ray/fields/types';
import { sylvanus } from '~/services/serviceInstances';
import { Nullable } from '~/types/Nullable';
import { Uuid } from '~/types/Uuid';

import { mapTableValue, mapValue } from './transformers';

interface Request {
  highlightMethod: string;
  modelId: Uuid;
  documentId: string;
  documentType: string;
}

type Response = PromptModelWorkflow;

export const getPromptModelWorkflowPredictionByDocument = async ({
  highlightMethod,
  modelId,
  documentId,
  documentType,
}: Request): Promise<Response> => {
  const response = await sylvanus.get(
    `/model/${modelId}/predict/${documentType}/${documentId}`,
  );

  const isTableModel = response.output?.value_type === 'table_value';
  return {
    ...response,
    output: response.output
      ? {
          ...response.output,
          ...(isTableModel
            ? mapTableValue(response.output as Nullable<TableValue>)
            : mapValue(
                response.output as Nullable<FieldValueBase>,
                highlightMethod,
              )),
        }
      : null,
  };
};
